export enum HedgeOrderBy {
  NAME = 'name',
  PLACED_AT = 'placedAt',
}
